import DceHTMLElement from "./DceHTMLElement";
import DceComponent from "../DceComponent";
import DceEngineEventDetails from "../events/DceEngineEventDetails";
import DceEngineEventsFactory from "../events/DceEngineEventsFactory";

export default class DceHTMLElementExtension {

    private element: DceHTMLElement;

    private initializedComponents: Array<string>;

    private components: Map<string, DceComponent<any>>;

    public constructor(element: DceHTMLElement) {
        this.initializedComponents = new Array<string>();

        this.components = new Map();
        this.element = element;

        this.element.addEventListener('dceEvent', ((e: CustomEvent<DceEngineEventDetails>) => {
            this.onDceEvent(e);
        }) as EventListener);

    }

    protected onDceEvent(e: CustomEvent<DceEngineEventDetails>){

        if(this.components.has(e.detail.component)){

            switch (e.detail.type) {

                case DceEngineEventsFactory.INIT_EVENT:
                    this.components.get(e.detail.component).onInit();
                    break;

                case DceEngineEventsFactory.REMOVE_EVENT:
                    this.components.get(e.detail.component).onRemove();
                    break;

            }
        }
    }


    public hasComponent(name: string): boolean {
        return this.initializedComponents.indexOf(name) !== -1;
    }

    public getComponent(name: string): DceComponent<any> {
        return this.components.get(name);
    }

    public addComponent(name: string, comp: DceComponent<any>) {
        this.components.set(name, comp);
        this.initializedComponents.push(name);
    }

    public getInitializedComponents(): string[] {
        return this.initializedComponents;
    }

}
